<template>
  <div>
    <div id="Scroll_header">
      <v-hover v-slot="{ hover }">
        <v-app-bar app dense clipped-left :elevation="hover ? 8 : 2" style="z-index:101">
          <v-app-bar-nav-icon class="mr-n3" color="black" @click="drawer = !drawer"/>  
          <v-toolbar-title class="d-none d-sm-block">
            {{$store.state.CustomInfo.SiteNm}} 방문예약시스템
          </v-toolbar-title>      
          <v-spacer></v-spacer>

          <!-- <v-avatar size="32" class="mr-1">
            <img :src="FilePath">
          </v-avatar> -->
          <v-avatar size="32" class="mr-1">
            <v-img :src="FilePath" />
          </v-avatar>
          <div style="min-width:60px;" class="mr-2">{{ CustomInfo.CustomNm }}님</div>
          <div style="min-width:100px;max-width:180px;">
            <v-autocomplete
              v-model="cMenu"
              :items="['SKTC', 'SKMP'].includes($store.state.CustomInfo.SiteId) ? zMenu_SKTC : ['SKMA'].includes($store.state.CustomInfo.SiteId) ? zMenu : ['SKMG14', 'SKMJ'].includes($store.state.CustomInfo.SiteId) ? zMenu1 : null"
              auto-select-first
              class="mt-2 mb-n4 red--text"
              flat
              dense
              solo
              ref="cbCorpRef"
              placeholder="메뉴찾기"
              item-text="name"
              item-value="id"
              no-data-text="일치하는 메뉴가 없습니다."
              color="black"
              @input="inputChanged">
              <!-- placeholder="검색어를 입력하세요." -->
            </v-autocomplete>

          </div>
          <v-btn icon @click="$store.dispatch('logout','MainBoard')"><v-icon>mdi-logout</v-icon></v-btn>
        </v-app-bar>   
      </v-hover>
    </div>


    <v-navigation-drawer v-model="drawer"  app dense width=250 style="z-index:100;padding-top:50px;">
    <!-- <v-navigation-drawer v-model="drawer" app dense clipped width=250 style="z-index:100;"> -->
      <v-list dense>
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="ml-n5">Home</v-list-item-title>
        </v-list-item>

        <v-list-group prepend-icon="mdi-account-details" no-action>
          <template v-slot:activator>          
            <v-list-item-title class="ml-n5">정보관리</v-list-item-title>          
          </template>        
          <v-list-item v-for="(item, i) in ZMenuInfo" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     

        <v-list-group prepend-icon="mdi-login-variant" no-action>
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">방문예약 신청</v-list-item-title>          
          </template>        
          <v-list-item v-for="(item, i) in ZMenuInOut" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     

        <v-list-group prepend-icon="mdi-smart-card" no-action>
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">방문증 분실 신고</v-list-item-title>          
          </template>        
          <v-list-item v-for="(item, i) in ZMenuPass" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     

        <v-list-group prepend-icon="mdi-truck-delivery" no-action>
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">업체물품 반입 신청</v-list-item-title>          
          </template>        
          <v-list-item v-for="(item, i) in ZMenuGood" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     

        <v-list-group prepend-icon="mdi-camera" no-action v-if="$store.state.CustomInfo.SiteId!='SKTC' && $store.state.CustomInfo.SiteId!='SKMP' &&  $store.state.CustomInfo.SiteId != 'SKMJ' && $store.state.CustomInfo.SiteId != 'SKMG14'">
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">사진촬영 허가 신청</v-list-item-title>
          </template>        
          <v-list-item v-for="(item, i) in ZMenuPhoto" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     
        <v-list-group prepend-icon="mdi-camera" no-action v-if="$store.state.CustomInfo.SiteId=='SKTC' || $store.state.CustomInfo.SiteId=='SKMP'">
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">카메라 대여 신청</v-list-item-title>
          </template>        
          <v-list-item v-for="(item, i) in ZMenuCamera" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     
        
        <v-list-group prepend-icon="mdi-comment" no-action>
          <template v-slot:activator>          
              <v-list-item-title class="ml-n5">커뮤니티</v-list-item-title>          
          </template>        
          <v-list-item v-for="(item, i) in ZMenuCum" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon class="ml-n5" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10" v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>     
        
      </v-list>
    </v-navigation-drawer>  
  </div>  
</template>

<script>
import router from "@/router/index"
// import BasicInfo from "../../BasicInfo.js";
import EventBus from '@/eventBus.js';
import {mapState} from "vuex";

export default {
  components: {
  },
  computed: {
    ...mapState(["CustomInfo"]),
  },

  data: () => ({
    drawer: true,
    cMenu : "",
    FilePath : "",
    zMenu : [
      {id:"MainBoard", name:"홈", group:""},
      {divider: true},
      {header:  "정보관리" },
      {id:"ChangeCustomInfo", name:"회원정보수정", group:"정보관리"},
      {id:"ChangeCompanyInfo", name:"업체정보 정정신청", group:"정보관리"},
      {id:"Penalty", name:"보안규정 위반내역", group:"정보관리"},
      {id:"MoveCompany", name:"소속업체 변경 신청", group:"정보관리"},
      {id:"ChangeCorpManger", name:"협력업체 관리자 신청", group:"정보관리"},
      {id:"PledgeStatus", name:"서약현황", group:"정보관리"},
      {id:"SecurityEducationStatus", name:"보안 교육 현황", group:"정보관리"},
      {divider: true},
      {header:  "방문예약 신청" },
      {id:"VisitGuide", name:"방문예약 신청안내", group:"출입 관리"},
      {id:"VisitReq", name:"방문예약 신청", group:"출입 관리"},
      {id:"VisitStatus", name:"방문예약 신청현황", group:"출입 관리"},
      {divider: true},
      {header:  "방문증 분실 신고" },
      {id:"PassGuide", name:"방문증 분실 신고 안내", group:"출입 관리"},
      {id:"PassReq", name:"방문증 분실 신고",group:"출입 관리"},
      {id:"PassStatus", name:"방문증 분실 신고 현황", group:"출입 관리"},      
      {divider: true},
      {header:  "업체물품 반입 신청" },
      {id:"CorCarryGuide", name:"업체물품 반입 신청 안내", group:"물품신청"},
      {id:"CorCarryReq", name:"업체물품 반입 신청", group:"물품신청"},
      {id:"CorCarryStatus", name:"업체물품 반입 신청 현황", group:"물품신청"},
      {divider: true},
      {header:  "사진촬영 허가 신청" },
      {id:"PictureGuide", name:"사진촬영 허가 신청 안내", group:"물품신청"},
      {id:"PictureReq", name:"사진촬영 허가 신청", group:"물품신청"},      
      {id:"PictureStatus", name:"사진촬영 허가 신청현황", group:"물품신청"},     
      {divider: true},
      {header:  "커뮤니티" },
      {id:"NoticeBoard", name:"공지사항", group:"커뮤니티"},
      {id:"FAQ", name:"FAQ", group:"커뮤니티"},
      {id:"Security", name:"보안준수사항 안내", group:"커뮤니티"},
    ], 

    zMenu1 : [
      {id:"MainBoard", name:"홈", group:""},
      {divider: true},
      {header:  "정보관리" },
      {id:"ChangeCustomInfo", name:"회원정보수정", group:"정보관리"},
      {id:"ChangeCompanyInfo", name:"업체정보 정정신청", group:"정보관리"},
      {id:"Penalty", name:"보안규정 위반내역", group:"정보관리"},
      {id:"MoveCompany", name:"소속업체 변경 신청", group:"정보관리"},
      {id:"ChangeCorpManger", name:"협력업체 관리자 신청", group:"정보관리"},
      {id:"PledgeStatus", name:"서약현황", group:"정보관리"},
      {id:"SecurityEducationStatus", name:"보안 교육 현황", group:"정보관리"},
      {divider: true},
      {header:  "방문예약 신청" },
      {id:"VisitGuide", name:"방문예약 신청안내", group:"출입 관리"},
      {id:"VisitReq", name:"방문예약 신청", group:"출입 관리"},
      {id:"VisitStatus", name:"방문예약 신청현황", group:"출입 관리"},
      {divider: true},
      {header:  "방문증 분실 신고" },
      {id:"PassGuide", name:"방문증 분실 신고 안내", group:"출입 관리"},
      {id:"PassReq", name:"방문증 분실 신고",group:"출입 관리"},
      {id:"PassStatus", name:"방문증 분실 신고 현황", group:"출입 관리"},      
      {divider: true},
      {header:  "업체물품 반입 신청" },
      {id:"CorCarryGuide", name:"업체물품 반입 신청 안내", group:"물품신청"},
      {id:"CorCarryReq", name:"업체물품 반입 신청", group:"물품신청"},
      {id:"CorCarryStatus", name:"업체물품 반입 신청 현황", group:"물품신청"},
      {divider: true},
      {header:  "사진촬영 허가 신청" },
      {id:"PictureGuide", name:"사진촬영 허가 신청 안내", group:"물품신청"},
      {id:"PictureReq", name:"사진촬영 허가 신청", group:"물품신청"},      
      {id:"PictureStatus", name:"사진촬영 허가 신청현황", group:"물품신청"},     
      {divider: true},
      {header:  "커뮤니티" },
      {id:"NoticeBoard", name:"공지사항", group:"커뮤니티"},
      {id:"FAQ", name:"FAQ", group:"커뮤니티"},
      {id:"Security", name:"보안준수사항 안내", group:"커뮤니티"},
    ], 
    //sktc, skmp 동일하
    zMenu_SKTC : [
      {id:"MainBoard", name:"홈", group:""},
      {divider: true},
      {header:  "정보관리" },
      {id:"ChangeCustomInfo", name:"회원정보수정", group:"정보관리"},
      {id:"ChangeCompanyInfo", name:"업체정보 정정신청", group:"정보관리"},
      {id:"Penalty", name:"보안규정 위반내역", group:"정보관리"},
      {id:"MoveCompany", name:"소속업체 변경 신청", group:"정보관리"},
      {id:"ChangeCorpManger", name:"협력업체 관리자 신청", group:"정보관리"},
      {id:"PledgeStatus", name:"서약현황", group:"정보관리"},
      {id:"SecurityEducationStatus", name:"보안 교육 현황", group:"정보관리"},
      {divider: true},
      {header:  "방문예약 신청" },
      {id:"VisitGuide", name:"방문예약 신청안내", group:"출입 관리"},
      {id:"VisitReq", name:"방문예약 신청", group:"출입 관리"},
      {id:"VisitStatus", name:"방문예약 신청현황", group:"출입 관리"},
      {divider: true},
      {header:  "방문증 분실 신고" },
      {id:"PassGuide", name:"방문증 분실 신고 안내", group:"출입 관리"},
      {id:"PassReq", name:"방문증 분실 신고",group:"출입 관리"},
      {id:"PassStatus", name:"방문증 분실 신고 현황", group:"출입 관리"},      
      {divider: true},
      {header:  "업체물품 반입 신청" },
      {id:"CorCarryGuide", name:"업체물품 반입 신청 안내", group:"물품신청"},
      {id:"CorCarryReq", name:"업체물품 반입 신청", group:"물품신청"},
      {id:"CorCarryStatus", name:"업체물품 반입 신청 현황", group:"물품신청"},
      {divider: true},
      {header:  "카메라 대여 신청" },
      {id:"CameraGuide", name:"카메라 대여 안내", group:"물품신청"},
      {id:"CameraReq", name:"카메라 대여 신청", group:"물품신청"},      
      {id:"CameraStatus", name:"카메라 대여 신청현황", group:"물품신청"},      
      {divider: true},
      {header:  "커뮤니티" },
      {id:"NoticeBoard", name:"공지사항", group:"커뮤니티"},
      {id:"FAQ", name:"FAQ", group:"커뮤니티"},
      {id:"Security", name:"보안준수사항 안내", group:"커뮤니티"},
    ], 

    zMenu_SKMJ : [
      {id:"MainBoard", name:"홈", group:""},
      {divider: true},
      {header:  "정보관리" },
      {id:"ChangeCustomInfo", name:"회원정보수정", group:"정보관리"},
      {id:"ChangeCompanyInfo", name:"업체정보 정정신청", group:"정보관리"},
      {id:"Penalty", name:"보안규정 위반내역", group:"정보관리"},
      {id:"MoveCompany", name:"소속업체 변경 신청", group:"정보관리"},
      {id:"ChangeCorpManger", name:"협력업체 관리자 신청", group:"정보관리"},
      {id:"PledgeStatus", name:"서약현황", group:"정보관리"},
      {id:"SecurityEducationStatus", name:"보안 교육 현황", group:"정보관리"},
      {divider: true},
      {header:  "방문예약 신청" },
      {id:"VisitGuide", name:"방문예약 신청안내", group:"출입 관리"},
      {id:"VisitReq", name:"방문예약 신청", group:"출입 관리"},
      {id:"VisitStatus", name:"방문예약 신청현황", group:"출입 관리"},
      {divider: true},
      {header:  "방문증 분실 신고" },
      {id:"PassGuide", name:"방문증 분실 신고 안내", group:"출입 관리"},
      {id:"PassReq", name:"방문증 분실 신고",group:"출입 관리"},
      {id:"PassStatus", name:"방문증 분실 신고 현황", group:"출입 관리"},      
      {divider: true},
      {header:  "업체물품 반입 신청" },
      {id:"CorCarryGuide", name:"업체물품 반입 신청 안내", group:"물품신청"},
      {id:"CorCarryReq", name:"업체물품 반입 신청", group:"물품신청"},
      {id:"CorCarryStatus", name:"업체물품 반입 신청 현황", group:"물품신청"},
      {divider: true},
      {header:  "커뮤니티" },
      {id:"NoticeBoard", name:"공지사항", group:"커뮤니티"},
      {id:"FAQ", name:"FAQ", group:"커뮤니티"},
      {id:"Security", name:"보안준수사항 안내", group:"커뮤니티"},
    ], 

    zMenu_SKMG14 : [
      {id:"MainBoard", name:"홈", group:""},
      {divider: true},
      {header:  "정보관리" },
      {id:"ChangeCustomInfo", name:"회원정보수정", group:"정보관리"},
      {id:"ChangeCompanyInfo", name:"업체정보 정정신청", group:"정보관리"},
      {id:"Penalty", name:"보안규정 위반내역", group:"정보관리"},
      {id:"MoveCompany", name:"소속업체 변경 신청", group:"정보관리"},
      {id:"ChangeCorpManger", name:"협력업체 관리자 신청", group:"정보관리"},
      {id:"PledgeStatus", name:"서약현황", group:"정보관리"},
      {id:"SecurityEducationStatus", name:"보안 교육 현황", group:"정보관리"},
      {divider: true},
      {header:  "방문예약 신청" },
      {id:"VisitGuide", name:"방문예약 신청안내", group:"출입 관리"},
      {id:"VisitReq", name:"방문예약 신청", group:"출입 관리"},
      {id:"VisitStatus", name:"방문예약 신청현황", group:"출입 관리"},
      {divider: true},
      {header:  "방문증 분실 신고" },
      {id:"PassGuide", name:"방문증 분실 신고 안내", group:"출입 관리"},
      {id:"PassReq", name:"방문증 분실 신고",group:"출입 관리"},
      {id:"PassStatus", name:"방문증 분실 신고 현황", group:"출입 관리"},      
      {divider: true},
      {header:  "업체물품 반입 신청" },
      {id:"CorCarryGuide", name:"업체물품 반입 신청 안내", group:"물품신청"},
      {id:"CorCarryReq", name:"업체물품 반입 신청", group:"물품신청"},
      {id:"CorCarryStatus", name:"업체물품 반입 신청 현황", group:"물품신청"},
      {divider: true},
      {header:  "커뮤니티" },
      {id:"NoticeBoard", name:"공지사항", group:"커뮤니티"},
      {id:"FAQ", name:"FAQ", group:"커뮤니티"},
      {id:"Security", name:"보안준수사항 안내", group:"커뮤니티"},
    ], 

    ZMenuInfo : [
      { text: "회원정보수정", icon: "mdi-account-edit", to: "/ChangeCustomInfo" },
      { text: "업체정보 정정신청", icon: "mdi-account-supervisor-circle-outline", to: "/ChangeCompanyInfo" }, 
      { text: "보안규정 위반내역", icon: "mdi-police-badge", to: "/Penalty" },
      { text: "소속업체 변경 신청", icon: "mdi-home-edit-outline", to: "/MoveCompany" },
      { text: "협력업체 관리자 신청", icon: "mdi-account-switch-outline", to: "/ChangeCorpManger" },
      { text: "서약현황", icon: "mdi-file-find-outline", to: "/PledgeStatus" }, 
      { text: "보안 교육현황", icon: "mdi-cast-education", to: "/SecurityEducationStatus" }, 
    ], 
    ZMenuInOut : [
      { text: "방문예약 신청 안내", icon: "mdi-monitor-eye", to: "/VisitGuide" },
      { text: "방문예약 신청", icon: "mdi-square-edit-outline", to: "/VisitReq" },
      { text: "방문예약 신청 현황", icon: "mdi-view-list-outline", to: "/VisitStatus" },
    ], 
    ZMenuPass : [
      { text: "방문증 분실 신고 안내", icon: "mdi-monitor-eye", to: "/PassGuide" },
      { text: "방문증 분실 신고", icon: "mdi-square-edit-outline", to: "/PassReq" },
      { text: "방문증 분실 신고 현황", icon: "mdi-view-list-outline", to: "/PassStatus" },
    ],
    ZMenuGood : [
      { text: "업체물품 반입 신청 안내", icon: "mdi-monitor-eye", to: "/CorCarryGuide" },
      { text: "업체물품 반입 신청", icon: "mdi-square-edit-outline", to: "/CorCarryReq" },
      { text: "업체물품 반입 신청 현황", icon: "mdi-view-list-outline", to: "/CorCarryStatus" },
    ],
    ZMenuPhoto : [
      { text: "사진촬영 허가 신청 안내", icon: "mdi-monitor-eye", to: "/PictureGuide" },
      { text: "사진촬영 허가 신청", icon: "mdi-square-edit-outline", to: "/PictureReq" },
      { text: "사진촬영 허가 신청 현황", icon: "mdi-view-list-outline", to: "/PictureStatus" },
    ],
    ZMenuCamera : [
      { text: "카메라 대여 신청 안내", icon: "mdi-monitor-eye", to: "/CameraGuide" },
      { text: "카메라 대여 신청", icon: "mdi-square-edit-outline", to: "/CameraReq" },
      { text: "카메라 대여 신청 현황", icon: "mdi-view-list-outline", to: "/CameraStatus" },
    ],
    ZMenuCum : [
      { text: "공지사항", icon: "mdi-checkbox-multiple-blank-outline", to: "/NoticeBoard" },
      { text: "FAQ", icon: "mdi-alert-circle", to: "/FAQ" },
      { text: "보안준수사항 안내", icon: "mdi-security", to: "/Security" },
    ],
  }),
  
  mounted () {
    this.FilePath = process.env.VUE_APP_FILE_API + this.CustomInfo.Path;
    EventBus.$on("onScrollIdView", (bReFresh) => {
      if (!bReFresh) {
        let timeout = setTimeout(() => {
          this.MoveScroll();
          clearTimeout(timeout);
        }, 300);
      } else {
        this.MoveScroll();
      }
    });
  },

  beforeDestroy(){
    EventBus.$off('onScrollIdView');
  },

  methods: {
    MoveScroll() {
      var element = document.getElementById("Scroll_header");
      if (element) {
        element.scrollIntoView({behavior : "smooth"})        
      }
    },

    inputChanged(){
      router.push({ name: this.cMenu });
    },

    ChangeImg(APIURL,Path){
      this.FilePath = APIURL + Path
    },
  }     
}
</script>